import { lazy, Suspense } from 'react';
const Loading = <div>Loading....</div>;
const CommnuityMainPage = lazy(() => import('../pages/CommunityMainPage'));
const ComminityPostPage = lazy(() => import('../pages/ComminityPostPage'));
const CommunityEditPage = lazy(() => import('../pages/CommunityEditPage'));

const communityFrontRouter = () => {
  return [
    {
      path: '',
      element: (
        <Suspense fallback={Loading}>
          <CommnuityMainPage />
        </Suspense>
      ),
    },
    {
      path: ':id',
      element: (
        <Suspense fallback={Loading}>
          <CommnuityMainPage />
        </Suspense>
      ),
    },
    {
      path: ':id/post/:postId',
      element: (
        <Suspense fallback={Loading}>
          <ComminityPostPage /> {/* 특정 커뮤니티의 특정 포스트 페이지 */}
        </Suspense>
      ),
    },
    {
      path: ':id/post/edit',
      element: (
        <Suspense fallback={Loading}>
          <CommunityEditPage /> {/* 커뮤니티 에디트 페이지 */}
        </Suspense>
      ),
    },
    {
      path: ':id/post/:postId/edit',
      element: (
        <Suspense fallback={Loading}>
          <CommunityEditPage /> {/* 커뮤니티 에디트 페이지 */}
        </Suspense>
      ),
    },
  ];
};

export default communityFrontRouter;
